import React, {useState, useEffect} from "react"
import keypadAnswerData from "./keypadAnswerData"
import KeypadLock from "./KeypadLock"
import Keypad from "./Keypad"
import PhaseComplete from "./PhaseComplete"
import Readout from "./Readout"

function SuspectKeypad(props) {
    const [correct, setCorrect] = useState("")
    const [userInput, setUserInput] = useState("_ _ _ - _ _ _ ")
    const [inputTextOne, setInputTextOne] = useState("")
    const [inputTextTwo, setInputTextTwo] = useState("")
    const [codeSubmitted, setCodeSubmitted] = useState(false)
    const [phaseComplete, setPhaseComplete] = useState(false)
    const [showError, setShowError] = useState(false)
    const [errorMessage, setErrorMessage] = useState("")
    const [nextPage, setNextPage] = useState(0)
    const [requiredUnlock, setRequiredUnlock] = useState(false)
    const [requiredText, setRequiredText] = useState("")
    const [correctUnlock, setCorrectUnlock] = useState("")
    let textOutput
    
    function suspectEliminated() {
        setPhaseComplete(true)
        props.callBackPartComplete(true)
        textOutput = "Next Phase Password = " + keypadAnswerData[props.currentPage].nextPassword
        setUserInput(textOutput)
    }
    
    useEffect(() => {
        setCorrect(keypadAnswerData[props.currentPage].correctAnswer)
        setNextPage(props.currentPage + 1)
        setRequiredText(keypadAnswerData[props.currentPage].codeText)
        setCorrectUnlock(keypadAnswerData[props.currentPage].unlockPassword)
        handleResetClick()
        setPhaseComplete(false)
        
        if (props.partStatus[props.currentPage].status === "complete") {
            console.log(props.partStatus[props.currentPage].status)
            suspectEliminated()
        } 
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [props.currentPage])
    
    function handleNumberClick(event) {
        let {name} = event.target
        const codeLength = 6
        let addTextOne = ""
        let addTextTwo = ""
        
        if (codeSubmitted === false) {
            if (inputTextOne.length < codeLength) {
                addTextOne = inputTextOne + name + " "
                addTextTwo = inputTextTwo
            } else if (inputTextTwo.length < codeLength) {
                addTextTwo = inputTextTwo + name + " "
                addTextOne = inputTextOne
            }
            
            setInputTextOne(addTextOne)
            setInputTextTwo(addTextTwo)
            textOutput = addTextOne.padEnd(codeLength, "_ ") + "- " + addTextTwo.padEnd(codeLength, "_ ")

            if (addTextTwo.length === codeLength) {
                setCodeSubmitted(true);
                if (textOutput === correct) {
                    suspectEliminated()
                } else {
                    if (keypadAnswerData[props.currentPage].eliminatedAnswers.includes(textOutput)) {
                        textOutput = "This is getting us nowhere!"
                        setErrorMessage("You have already eliminated that suspect from the investigation.")
                        setShowError(true)
                    } else if (keypadAnswerData[0].referenceNumbers.includes(textOutput)) {
                        textOutput = "Are you sure?"
                        setErrorMessage("You might want to check your working. We don't have enough evidence to eliminate them from the investigation yet.")
                        setShowError(true)
                    } else {
                        textOutput = "That reference number doesn't exist."
                    }
                }
            }
            setUserInput(textOutput)
        }
    }
    
    function handleResetClick() {
        setCodeSubmitted(false)
        setInputTextOne("")
        setInputTextTwo("")
        setUserInput("_ _ _ - _ _ _ ")
        setShowError(false)
    }
    
    function nextPhase() {
        const pageTarget = nextPage
        setPhaseComplete(false)
        props.callBack(pageTarget) 
    }
    
    function handleKeypadUnlock() {
        setRequiredUnlock(false)
    }
    
    useEffect(() => {
        console.log(props.keypadUnlock)
        if (props.keypadUnlock) { 
            handleKeypadUnlock() 
        } else {
            setRequiredUnlock(true)
        }
    },[props.keypadUnlock, props.currentPage])
    
    const keypad = !phaseComplete ? 
    <Keypad handleNumberClick={handleNumberClick} handleResetClick={handleResetClick} currentPage={props.currentPage}/> :
    <PhaseComplete nextPage={nextPage} nextPhase={nextPhase}/>

    return (
        <div>
            <div>
                <h2>Eliminate A Suspect From The Investigation</h2>
                <h3>Enter their suspect reference number.</h3>

                {requiredUnlock ? "" : <Readout output={userInput} phaseComplete={phaseComplete} codeSubmitted={codeSubmitted}/>}
                <h3>{showError ? errorMessage : ""}</h3>
                {requiredUnlock ? <KeypadLock requiredText={requiredText} callBackStatus={handleKeypadUnlock} correct={correctUnlock} currentPage={props.currentPage} /> : keypad}
                <br /> <br />
            </div>
        </div>
    )
}

export default SuspectKeypad